import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../../context/MyContext';

import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { PiWarehouseFill } from "react-icons/pi";
import { toast } from 'react-toastify';
import '../../../../css/custom-scrollbar.css';
import { Addwarehouse, Base_Url, getpincode, fetchUser } from '../../../../config/config';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";
import {
  User,
  Phone,
  Mail,
  MapPin,
  Building2,
  Globe,
  Hash,
  ChevronDown,
  Users,
  Loader2,
} from "lucide-react";

const schema = z.object({
  facilityName: z.string()
    .min(1, "Facility name is required")
    .regex(/^[A-Za-z\s]+$/, "Facility name must only contain letters and spaces"),
  contactPerson: z.string()
    .min(1, "Contact Person is required")
    .regex(/^[A-Za-z\s]+$/, "Contact Person must only contain letters and spaces"),
  phone: z.string()
    .length(10, "Phone number must be exactly 10 digits")
    .regex(/^\d+$/, "Phone number must be numeric"),
  pincode: z.string()
    .min(6, "Pincode should be exactly 6 characters")
    .max(6, "Pincode should be exactly 6 characters")
    .regex(/^\d+$/, "Pincode must be numeric"),
  city: z.string().min(1, "City is required").regex(/^[a-zA-Z\s]+$/, "City must only contain alphabetic characters"),
  state: z.string().min(1, "State is required").regex(/^[a-zA-Z\s]+$/, "State must only contain alphabetic characters"),
  email: z.string().optional(),
  address: z
  .string()
  .min(1, "Address is required")
  .regex(/^[^#\\%&;]*$/, "Address contains invalid characters (# \\ % & ; not allowed)"),
  returnAddress: z.string().optional(),
  returnState: z.string().optional(),
  returnCity: z.string().optional(),
  returnCountry: z.string().optional(),
  returnPincode: z.string().optional()
});

const AddWarehouse = () => {
  const [showReturnAddress, setShowReturnAddress] = useState(false);
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reatilerId, setRetailerId] = useState('')
  const [retailerIdData, setRetailerIdData] = useState([]);
  const role = localStorage.getItem("role");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue
  } = useForm({
    resolver: zodResolver(schema),
  });


  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };

  const handleInputChange = (event) => {
    const { value, id } = event.target;

    if (['pincode', 'phone', 'return-pincode'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;

      if (id === 'return-pincode' && filteredValue.length === 6) {
        fetchreturnPincodeData(filteredValue);
      }
      if (id === "pincode") {
        if (filteredValue.length < 6) {
          setValue("city", "");
          setValue("state", "");
        } else if (filteredValue.length === 6) {
          fetchPincodeData(filteredValue);
        }
      }
    }
    if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;

    }
  };

  const navigate = useNavigate();
  const navigate1 = useNavigate();

  const naviagation = () => {
    navigate('/dashboard');
  }

  useEffect(() => {
    fetchReatiler();
  }, []);

  const fetchPincodeData = async (pincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        setValue("city", city);
        setValue("state", state);
      }


      else if (data && data.message === "Unauthorized access - Invalid token") {
        // toast.error(data.message + " Please login Again");
      }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }


      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const fetchreturnPincodeData = async (returnPincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });


      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

        setValue("returnCity", city);
        setValue("returnState", state);
      }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }
      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();
    const token = localStorage.getItem('token');
    let cusid = localStorage.getItem('cus_id');
    const adminId = localStorage.getItem('cus_id');
    setIsSubmitting(true);
    try {
      if (role == "admin") {
        cusid = reatilerId;
      } else {
        cusid = cusid;
      }
      const payload = {
        name: data.facilityName,
        email: data.email,
        phone: data.phone,
        address: data.address,
        pincode: data.pincode,
        city: data.city,
        contact_person: data.contactPerson,
        state: data.state,
        country: "India",
        customer_id: cusid,
        return_warehouse: showReturnAddress ? "true" : "false",
        return_address: data.returnAddress || '',
        return_city: data.returnCity || '',
        return_state: data.returnState || '',
        return_country: data.returnCountry || 'India',
        return_pincode: data.returnPincode || '',
      };

      const response = await axios.post(Base_Url + Addwarehouse, payload, {
        headers: {
          'token': token,
          'cus_id': adminId,
          'Content-Type': 'application/json',

        },
      });

      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        setIsSubmitting(false);
        setTimeout(() => {
          navigate1('/warehouse/all')
        })
      } else {
        throw new Error(response.data.message || 'Failed to save warehouse');
        setIsSubmitting(false);
      }
    } catch (error) {
      const errorMessagecontact_person = error.response?.data?.errors?.contact_person || "";
      const address = error.response?.data?.errors?.address || "";
      const email = error.response?.data?.errors?.email || "";
      const name = error.response?.data?.errors?.name || "";
      const return_country = error.response?.data?.errors?.return_country || "";
      const return_address = error.response?.data?.errors?.return_address || "";
      const return_pincode = error.response?.data?.errors?.return_address || "";
      const return_city = error.response?.data?.errors?.return_city || "";
      const return_state = error.response?.data?.errors?.return_city || "";
      const customer_id = error.response?.data?.errors?.customer_id || "";
      toast.error(errorMessagecontact_person || address || return_country || name || return_address || return_pincode || return_city || return_state || customer_id || email);
      setIsSubmitting(false);
    }
  };

  // fatch all reatlier for admin 
  const fetchReatiler = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const headers = new Headers({
      'token': token,
      'cus_id': cusid,
      'Content-Type': 'application/json'
    });

    try {
      const response = await fetch(Base_Url + fetchUser, {

        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = data.data.map(retailer => ({
        value: retailer.id,
        label: retailer.name,
      }));
      setRetailerIdData(transformedData)
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // function for set the retailer id 

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectedItem = retailerIdData.find((item) => item.value === selectedValue);
    if (selectedItem) {
      setRetailerId(selectedItem.value);
    } else {
      setRetailerId("");
    }
  };

  const fieldBaseClass = (hasError) =>
    `w-full pl-7 pr-2.5 py-1 text-[10px] rounded-lg border transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400 disabled:cursor-not-allowed disabled:opacity-60 ${
      hasError ? 'border-red-500' : isDarkMode ? 'border-blue/15 bg-black text-white placeholder-white/30' : 'border-blue/15 bg-white text-black placeholder-black/50'
    }`;
    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
             <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

        <NavBar />
        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
              <Sidebar />
            </div>
          )}

          <div className="p-2 flex flex-1 flex-col bg-gray-100 ">
            {/* Page header */}
            <div className={`flex items-center  gap-2 mb-2.5 border rounded-lg px-3 py-2 ${isDarkMode ? 'border-white/10 bg-black' : 'border-black/10 bg-white'}`}>
              <div className={`p-1.5 rounded-lg ${isDarkMode ? 'bg-white/10' : 'bg-black/10'}`}>
                <PiWarehouseFill color='blue' className={`text-sm ${isDarkMode ? 'text-white' : 'text-black'}`} />
              </div>
              <div>
                <h2 className={`text-xs font-bold leading-tight ${isDarkMode ? 'text-white' : 'text-black'}`}>Add New Pickup Location</h2>
                <p className={`text-[8px] ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>Fill in the facility details to register a new warehouse</p>
              </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit, onErrors)} className={`border w-full rounded-lg px-3 py-2.5 ${isDarkMode ? 'border-white/10 bg-black' : 'border-black/10 bg-white'}`}>

              {/* Section: Facility details */}
              <div className="flex items-center gap-1.5 mb-1.5">
                <Building2 color='blue' className={`w-3.5 h-3.5 ${isDarkMode ? 'text-white/60' : 'text-black/60'}`} />
                <h3 className={`text-[13px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>Facility Details</h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                {role === 'admin' && (
                  <div className="relative">
                    <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`}>Select Retailer</label>
                    <div className="relative">
                      <Users color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                      <select
                        id="retailer"
                        className={`${fieldBaseClass(errors.facilityName)} appearance-none`}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select Retailer</option>
                        {retailerIdData.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <ChevronDown color='blue' className={`pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-3 h-3 ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    </div>
                    {errors.warehouse && (
                      <p className="text-red-500 text-[8px] mt-0.5">{errors.warehouse.message}</p>
                    )}
                  </div>
                )}
                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="facility-name">
                    Facility Name
                  </label>
                  <div className="relative">
                    <Building2 color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.facilityName)}
                      id="facility-name"
                      type="text"
                      placeholder="Enter name"
                      {...register('facilityName')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.facilityName && <p className="text-red-500 text-[8px] mt-0.5">{errors.facilityName.message}</p>}
                </div>
                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="contact-person">
                    Contact Person
                  </label>
                  <div className="relative">
                    <User color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.contactPerson)}
                      id="contact-person"
                      type="text"
                      placeholder="Enter contact person name"
                      {...register('contactPerson')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.contactPerson && <p className="text-red-500 text-[8px] mt-0.5">{errors.contactPerson.message}</p>}
                </div>


                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="pincode">
                    Pincode
                  </label>
                  <div className="relative">
                    <Hash color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.pincode)}
                      id="pincode"
                      type="text"
                      maxLength="6"
                      placeholder="Enter pincode"
                      {...register('pincode')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.pincode && <p className="text-red-500 text-[8px] mt-0.5">{errors.pincode.message}</p>}
                </div>

                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="city">
                    City
                  </label>
                  <div className="relative">
                    <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.city)}
                      id="city"
                      type="text"
                      placeholder="Enter City"
                      {...register('city')}
                      disabled
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.city && <p className="text-red-500 text-[8px] mt-0.5">{errors.city.message}</p>}
                </div>
                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="state">
                    State
                  </label>
                  <div className="relative">
                    <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.state)}
                      id="state"
                      type="text"
                      placeholder="Enter state"
                      {...register('state')}
                      disabled
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.state && <p className="text-red-500 text-[8px] mt-0.5">{errors.state.message}</p>}
                </div>

                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="phone">
                    Phone
                  </label>
                  <div className="relative">
                    <Phone color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.phone)}
                      id="phone"
                      type="tel"
                      maxLength="10"
                      placeholder="Enter 10 digit mobile no."
                      {...register('phone')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.phone && <p className="text-red-500 text-[8px] mt-0.5">{errors.phone.message}</p>}
                </div>

                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="email">
                    Email
                  </label>
                  <div className="relative">
                    <Mail color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.email)}
                      id="email"
                      type="email"
                      placeholder="Enter email"
                      {...register('email')}
                    />
                  </div>
                </div>
                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="country">
                    Country
                  </label>
                  <div className="relative">
                    <Globe color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.country)}
                      id="country"
                      type="text"
                      disabled
                      placeholder="India"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div>
                  <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="address">
                    Address
                  </label>
                  <div className="relative">
                    <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                    <input
                      className={fieldBaseClass(errors.address)}
                      id="address"
                      type="text"
                      placeholder="Enter complete address"
                      {...register('address')}
                    />
                  </div>
                  {errors.address && <p className="text-red-500 text-[12px] mt-0.5">{errors.address.message}</p>}
                </div>
              </div>

              {/* Return address toggle */}
              <div className={`mt-2 pt-1.5 border-t ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
                <label className="flex items-center gap-1.5 cursor-pointer w-fit">
                  <input
                    type="checkbox"
                    checked={showReturnAddress}
                    onChange={(e) => setShowReturnAddress(e.target.checked)}
                    className={`form-checkbox h-3.5 w-3.5 rounded ${isDarkMode ? 'bg-black border-white/20 text-white' : 'bg-white border-black/20 text-black'}`}
                  />
                  <span className={`text-[12px] font-medium ${isDarkMode ? 'text-white/60' : 'text-black/60'}`}>Different return address</span>
                </label>
              </div>

              {showReturnAddress && (
                <div className="mt-2">
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <MapPin color='blue' className={`w-3.5 h-3.5 ${isDarkMode ? 'text-white/60' : 'text-black/60'}`} />
                    <h3 className={`text-[12px] font-semibold ${isDarkMode ? 'text-white' : 'text-black'}`}>Return Address</h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                    <div>
                      <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="return-address">
                        Return Address
                      </label>
                      <div className="relative">
                        <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                        <input
                          className={fieldBaseClass(false)}
                          id="returnAddress"
                          type="text"
                          placeholder="Enter return address"
                          {...register('returnAddress')}
                        />
                      </div>
                    </div>
                    <div>
                      <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="return-country">
                        Return Country
                      </label>
                      <div className="relative">
                        <Globe color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                        <input
                          className={fieldBaseClass(false)}
                          id="returnCountry"
                          type="tel"
                          disabled
                          placeholder="India"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div>
                      <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="return-pincode">
                        Return Pincode
                      </label>
                      <div className="relative">
                        <Hash color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                        <input
                          className={fieldBaseClass(false)}
                          id="return-pincode"
                          type="text"
                          maxLength="6"
                          placeholder="Enter return pincode"
                          {...register('returnPincode')}
                          onChange={handleInputChange}

                        />
                      </div>
                    </div>
                    <div>
                      <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="return-city">
                        Return City
                      </label>
                      <div className="relative">
                        <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                        <input
                          className={fieldBaseClass(false)}
                          id="returnCity"
                          type="text"
                          placeholder="Enter return City"
                          {...register('returnCity')}
                          onChange={handleInputChange}

                        />
                      </div>
                    </div>
                    <div>
                      <label className={`block text-[12px] font-medium mb-0.5 ${isDarkMode ? 'text-white/50' : 'text-black/50'}`} htmlFor="return-state">
                        Return State
                      </label>
                      <div className="relative">
                        <MapPin color='blue' className={`absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 pointer-events-none ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} />
                        <input
                          className={fieldBaseClass(false)}
                          id="returnState"
                          type="text"
                          placeholder="Enter return State"
                          {...register('returnState')}
                          onChange={handleInputChange}

                        />
                      </div>
                    </div>

                  </div>
                </div>
              )}

              <div className="flex items-center justify-center mt-2.5">
                <button
                  className={`flex items-center justify-center gap-1.5 text-[10px] font-semibold py-1.5 px-4 rounded-lg transition-all duration-200 active:scale-[0.99] w-full disabled:opacity-60 ${isDarkMode ? 'bg-white text-black hover:bg-white/90' : 'bg-blue-600 text-white hover:bg-blue-400'}`}
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting && <Loader2 className="w-3 h-3 animate-spin" />}
                  {isSubmitting ? "Creating Warehouse..." : 'Create Warehouse'}
                </button>
              </div>
            </form>
          </div>
       
        </div>
      
    </div>
  );
};

export default AddWarehouse;